module.exports = __webpack_public_path__ + "img/2.855344a2.jpg";